var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    stroke: "#fff",
    strokeOpacity: 0.4,
    strokeWidth: 1.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#D9D9D9",
    d: "M19 19h4v10h-4zM19 13h4v4h-4z"
  })));
}

export default SvgInfo;